export default "__VITE_ASSET__b3819891__"